import { compareAsc, format, getDate, getMonth, getYear, isDate } from 'date-fns'
import { ko } from 'date-fns/locale'
import { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useCafSummaryDatesV5 } from '../../../../../modules/apis/webview/caf'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { ICON_CHEVRON_LEFT_BLACK, ICON_CHEVRON_RIGHT_BLACK } from '../../../../../modules/svg/svg'

export const enum DATE_POSITION {
  START = 'start',
  END = 'end',
}

interface ICalendar {
  setDate: (date: Date) => void
  currentDate: Date
  // 두 개의 캘린더를 이용해 기간 설정 시에, 필요한 값
  position?: string
  dateToCompare?: Date
  setUpdateBoth?: (updateBoth: boolean) => void
}

const Calendar = ({ setDate, currentDate: date, position, dateToCompare, setUpdateBoth }: ICalendar) => {
  const currentDate = isDate(date) ? date : new Date(date)
  const { t, isLocaleKO } = useTranslation()
  const today = new Date()
  const [year, setYear] = useState<number>(getYear(currentDate))
  const [month, setMonth] = useState<number>(getMonth(currentDate) + 1)
  const [tempDate, setTempDate] = useState(currentDate)
  const { data, refetch } = useCafSummaryDatesV5({
    year,
    month,
  })
  useEffect(() => {
    refetch()
  }, [month])

  const renderDayContents = (day: number, date: Date) => {
    return (
      <div className="flex h-[30px] flex-col items-center justify-between">
        <div className="flex h-[24px] items-center ">{getDate(date)}</div>
        {data?.caf_dates?.find((cafDate) => cafDate === format(date, 'yyyy-MM-dd')) ? ( // TEST
          <div className="h-[4px] w-[4px] rounded-full bg-purple-500" />
        ) : (
          <div className="h-[4px] w-[4px]" />
        )}
      </div>
    )
  }

  const changeDate = (date: Date) => {
    if (position && dateToCompare && setUpdateBoth) {
      if (
        (position === DATE_POSITION.START && compareAsc(date, dateToCompare) === 1) ||
        (position === DATE_POSITION.END && compareAsc(dateToCompare, date) === 1)
      ) {
        setUpdateBoth(true)
      } else {
        setUpdateBoth(false)
      }
    }
    setTempDate(date)
    setDate(date)
  }

  return (
    <div className="custom-react-datepicker">
      <DatePicker
        onChange={(date: Date) => changeDate(date)}
        locale={isLocaleKO && ko}
        dateFormat="yyyy/MM/dd"
        selected={tempDate}
        inline
        minDate={data?.start_date ? new Date(data.start_date) : new Date('2015-06-08')}
        maxDate={today}
        renderCustomHeader={({
          date,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div className="flex w-full items-center justify-center bg-white px-[24px] pb-[16px]">
            <button
              onClick={() => {
                decreaseMonth()
                setYear(getMonth(date) === 0 ? getYear(date) - 1 : getYear(date))
                setMonth(getMonth(date) === 0 ? 12 : getMonth(date))
              }}
              disabled={prevMonthButtonDisabled}
            >
              <img src={ICON_CHEVRON_LEFT_BLACK} height="10px" alt="Previous" />
            </button>
            <div className="px-[24px] text-[16px] font-bold">
              {isLocaleKO ? format(date, 'yyyy년 MM월') : format(date, 'LLLL yyyy')}
            </div>
            <button
              onClick={() => {
                increaseMonth()
                setYear(getMonth(date) === 11 ? getYear(date) + 1 : getYear(date))
                setMonth(getMonth(date) === 11 ? 1 : getMonth(date) + 2)
              }}
              disabled={nextMonthButtonDisabled}
            >
              <img src={ICON_CHEVRON_RIGHT_BLACK} height="10px" alt="Next" />
            </button>
          </div>
        )}
        renderDayContents={renderDayContents}
      />
    </div>
  )
}

export default Calendar
